import React, { Component, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Trans, withI18n } from '@lingui/react';

import { connect } from 'react-redux';

import * as constants from '../constants';
import { getAssetThumbUrl } from '../api';
import { selectors } from '../reducers/userReducer';
import { selectors as appSelectors } from '../reducers/appReducer';

import RenderEmpty from './ArticleComponents/ItemDataCategoryTable/RenderEmpty'
import RenderFileList from './ArticleComponents/ItemDataCategoryTable/RenderFileList'
import RenderListini from './ArticleComponents/ItemDataCategoryTable/RenderListini'
import RenderImageList from './ArticleComponents/ItemDataCategoryTable/RenderImageList'
import RenderTextList from './ArticleComponents/ItemDataCategoryTable/RenderTextList';
import RenderIntegrations from './ArticleComponents/ItemDataCategoryTable/RenderIntegrations';
import RenderGiacenze from './ArticleComponents/ItemDataCategoryTable/RenderGiacenze';
import RenderPinaxo from './ArticleComponents/ItemDataCategoryTable/RenderPinaxo';
import ArticleDigitalAssetContainer from './ArticleComponents/ArticleDigitalAssets/ArticleDigitalAssetContainer';
import { SECTION_TYPE_NEW_ASSETS } from '../constants';

export class ItemDataCategoryTable extends Component {
    state = {
        sortBy: null,
        sortDirection: 'asc',
    };

    getSorting() {
        return this.state;
    }

    toggleSort = (field) => {
        console.log(field)
        this.setState((prevState) => {
            return {
                sortBy: field,
                sortDirection:
                    prevState.sortBy !== field
                        ? 'asc'
                        : prevState.sortDirection === 'asc'
                        ? 'desc'
                        : 'asc',
            };
        });
    };

    // renderTextList() {
    //     const { category } = this.props;
    //
    //     const isCorrelati = category.key === constants.SECTION_KEY_CORRELATI;
    //
    //     return isCorrelati ?
    //         <RenderCorrelatiList
    //             data={this.props}
    //             sortBy={this.state.sortBy}
    //             sortDirection={this.state.sortDirection}
    //             toggleSort={this.toggleSort}
    //             getSorting={this.getSorting()}
    //         />
    //         :
    //         <RenderSimpleTextList
    //             attributes={this.props.attributes}
    //             type={this.props.type}
    //         />
    // }

    getFileThumbnailPath(fileName) {
        return getAssetThumbUrl(fileName);
    }

    renderList() {
        const { type } = this.props

        switch (type) {
            case constants.SECTION_TYPE_FILES:
                return (
                    <RenderFileList
                        data={this.props}
                        stateSortBy={this.state.sortBy}
                        stateSortDirection={this.state.sortDirection}
                        user={this.props.user ? this.props.user?.toJS() : null}
                        toggleSort={this.toggleSort}
                        getSorting={this.getSorting()}
                    />
                )
            case constants.SECTION_TYPE_IMAGES:
                return (
                    <RenderImageList
                    data={this.props}
                    user={this.props.user ? this.props.user?.toJS() : null}
                    stateSortBy={this.state.sortBy}
                    stateSortDirection={this.state.sortDirection}
                    toggleSort={this.toggleSort}
                    getSorting={this.getSorting()}
                    />
                )
            case constants.SECTION_TYPE_LISTINI:
                return (
                    <RenderListini
                        attributes={this.props.attributes}
                        toggleSort={this.toggleSort}
                        getSorting={this.getSorting()}
                    />
                )
            case constants.SECTION_TYPE_INTEGRATIONS:
                const everprice = this.props.articleDetails.integrations ? this.props.articleDetails.integrations : null
                return (
                    <RenderIntegrations
                        integrations={everprice}
                    />
                )
            case constants.SECTION_TYPE_INTEGRATIONS_GIACENZE:
                const giacenzeData = this.props.articleDetails.integrations ? this.props.articleDetails.integrations : null
                return (
                    <RenderGiacenze
                        giacenze={giacenzeData}
                    />
                )
            case constants.SECTION_TYPE_PINAXO:
                const pinaxoData = this.props.articleDetails.pinaxo ? this.props.articleDetails.pinaxo : null

                return (
                    <RenderPinaxo
                        data={pinaxoData}
                        user={this.props.user?.toJS?.() || {}}
                        itemData={this.props}
                    />
                )

            case constants.SECTION_TYPE_NEW_ASSETS:
                const { attributes, attributesMeta, category, articleDetails } = this.props;
                //console.log('ItemDataCategoryTable', attributes, attributesMeta, category)
                return (
                    <ArticleDigitalAssetContainer
                        assets={attributes}
                        assetsMeta={attributesMeta}
                        category={category}
                        articleDetails={articleDetails}
                    ></ArticleDigitalAssetContainer>
                )
            default:
                return (
                    <RenderTextList
                        data={this.props}
                        attributes={this.props.attributes}
                        category={this.props.category}
                        type={this.props.type}
                        sortBy={this.state.sortBy}
                        sortDirection={this.state.sortDirection}
                        toggleSort={this.toggleSort}
                        getSorting={this.getSorting()}
                    />
                )
        }
    }

    render() {
        const { type, showGiacenze } = this.props
        const { attributes } = this.props;

        // For SECTION_TYPE_INTEGRATIONS_GIACENZE, also check if showGiacenze parameter is true
        if (type === constants.SECTION_TYPE_INTEGRATIONS_GIACENZE && !showGiacenze) {
            return null;
        }

        // For integration types, skip the empty check since data comes from articleDetails
        if (type === constants.SECTION_TYPE_INTEGRATIONS || type === constants.SECTION_TYPE_INTEGRATIONS_GIACENZE) {
            return this.renderList();
        }

        return attributes.length === 0  ?
            <RenderEmpty />
            :
            this.renderList()
    }
}

ItemDataCategoryTable.propTypes = {
    selectedFilter: PropTypes.string,
    attributes: PropTypes.array,
    attributesMeta: PropTypes.object,
    category: PropTypes.object,
    isRepeatable: PropTypes.bool,
    onClick: PropTypes.func,
    showPreview: PropTypes.bool,
    type: PropTypes.string,
};

ItemDataCategoryTable.defaultProps = {
    attributes: [],
};

function mapStateToProps(state) {
    return {
        user: selectors.getUser(state),
        showGiacenze: appSelectors.getShowGiacenze(state),
    };
}

const ConnectedItemDataCategoryTable = connect(mapStateToProps)(ItemDataCategoryTable);

export default withI18n()(ConnectedItemDataCategoryTable);
